                    <div class="flex flex-wrap items-center gap-3 overflow-x-auto pb-2">
                        <ng-container *ngFor="let step of steps">
                            <button type="button"
                                (click)="goToStep(step.id)"
                                class="flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold border transition"
                                [ngClass]="{
                                    'bg-[#AA9072] text-white border-[#AA9072]': currentStep === step.id,
                                    'border-white/20 text-white/70 hover:bg-white/10': currentStep !== step.id
                                }">
                                <span class="h-6 w-6 rounded-full border flex items-center justify-center"
                                    [ngClass]="{ 'border-white bg-white/10': currentStep !== step.id, 'border-white/30 bg-white/20': currentStep === step.id }">
                                    {{ step.id }}
                                </span>
                                {{ step.label }}
                            </button>
                        </ng-container>
                    </div>
